var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _circle, _path10, _path11, _path12, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 250,
    viewBox: "0 0 321 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.438 12.0628C156.131 -2.06336 216.127 34.6646 246.125 81.3894C276.123 127.897 275.688 184.401 250.255 216.783C224.822 249.164 174.391 257.423 136.133 243.514C97.6569 229.388 71.3543 193.094 66.7894 142.24C62.0071 91.3864 78.9624 26.1889 117.438 12.0628Z",
    fill: "#52A0F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M261 58C261 58 231 64 223.5 60.5L188 221C188 221 211.5 225 230.5 216L261 58Z",
    fill: "#E6EBFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M243.5 149C243.5 149 210.5 156.5 216 191.5C210.501 199 200.001 200.5 200 221.5C200 221.5 211.5 225 230.5 216L243.5 149Z",
    fill: "#C8E2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M223.5 60.5C223.5 60.5 214.5 48 197 41.5L160.5 196C173.5 203 188 221 188 221L223.5 60.5Z",
    fill: "#C0D0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197 41.5C192 47 160.5 50.5 160.5 50.5L125.5 196C125.5 196 142 192 160.5 196L197 41.5Z",
    fill: "#E6EBFD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.996 41C191.996 46.5 160.496 50 160.496 50C149.996 89 166.496 81.5 166.496 81.5C181.996 86.5 158 116.5 181.5 107L196.996 41Z",
    fill: "#03366D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 50.5C160.5 50.5 155 41.5 125.5 33L90.5 192C121 190 125.5 196 125.5 196L160.5 50.5Z",
    fill: "#C0D0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.5 33C119.5 37 83.5 47 83.5 47L52 192C52 192 77 198.5 90.5 192L125.5 33Z",
    fill: "#E6EBFD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75 169.5C75 158.5 92 127 67.5 120L52 191.5C52 191.5 77 198 90.5 191.5C90.5 191.5 93 183 92 181.5C91 179 75 178.5 75 169.5Z",
    fill: "#011C38"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M88 105.5L114 154.5L170 114L196.5 181.5L295 65.5",
    stroke: "#00244B",
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M311 46.5C311 46.5 302 50.5 295 66C288 50.5 279 46.5 279 46.5H311Z",
    fill: "#52A0F5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 295,
    cy: 26,
    r: 26,
    fill: "#52A0F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M285.852 16.4812L304.815 35.4442",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M285.852 35.4443L304.815 16.4814",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4602 93.4035C98.4602 93.4035 92.5756 96.0189 87.9986 106.154C83.4217 96.0189 77.5371 93.4035 77.5371 93.4035H98.4602Z",
    fill: "#03366D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 80,
    r: 17,
    fill: "#03366D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.9979,
    cy: 80.0001,
    r: 5.88462,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 180,
    r: 5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 113,
    r: 5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 154,
    r: 5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 70,
    r: 28,
    fill: "#C8E2FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95L44 92L50.5 84.5L54 95Z",
    fill: "#C8E2FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.876 74.504C25.876 73.664 26.008 72.944 26.272 72.344C26.56 71.72 26.884 71.216 27.244 70.832C27.628 70.448 28.144 69.98 28.792 69.428C28.888 69.356 29.188 69.104 29.692 68.672C30.22 68.24 30.616 67.772 30.88 67.268C31.144 66.74 31.276 66.176 31.276 65.576C31.276 64.64 30.976 63.872 30.376 63.272C29.8 62.648 29.056 62.336 28.144 62.336C27.208 62.336 26.428 62.672 25.804 63.344C25.18 63.992 24.868 64.784 24.868 65.72V66.764L20.98 66.584V65.72C20.98 64.4 21.292 63.224 21.916 62.192C22.54 61.136 23.404 60.308 24.508 59.708C25.612 59.108 26.86 58.808 28.252 58.808C29.596 58.808 30.796 59.096 31.852 59.672C32.908 60.224 33.724 61.004 34.3 62.012C34.9 62.996 35.2 64.124 35.2 65.396C35.2 66.332 35.056 67.148 34.768 67.844C34.504 68.516 34.18 69.068 33.796 69.5C33.412 69.932 32.908 70.412 32.284 70.94C32.164 71.06 31.828 71.348 31.276 71.804C30.748 72.236 30.352 72.692 30.088 73.172C29.848 73.652 29.728 74.168 29.728 74.72V75.98H25.876V74.504ZM25.3 80.624C25.3 79.928 25.54 79.34 26.02 78.86C26.524 78.356 27.148 78.104 27.892 78.104C28.588 78.104 29.188 78.356 29.692 78.86C30.196 79.34 30.448 79.928 30.448 80.624C30.448 81.368 30.196 81.992 29.692 82.496C29.188 83 28.588 83.252 27.892 83.252C27.148 83.252 26.524 83 26.02 82.496C25.54 81.992 25.3 81.368 25.3 80.624Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHome);
export default __webpack_public_path__ + "static/media/empty-home.b6689638632602da427262bcd3881493.svg";
export { ForwardRef as ReactComponent };